"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5508,8773,5312,7643],{

/***/ 37643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ pushGoogleTabEvent; },
/* harmony export */   "s": function() { return /* binding */ createHomeArticlePayload; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var logging_log_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15079);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var pushGoogleTabEvent = function pushGoogleTabEvent(eventName, payload) {
  if (true) {
    var _window = window,
        dataLayer = _window.dataLayer;

    if (dataLayer) {
      try {
        dataLayer.push(_objectSpread(_objectSpread({}, payload), {}, {
          event: eventName
        }));
        console.log("success", _objectSpread(_objectSpread({}, payload), {}, {
          event: eventName
        }));
      } catch (error) {
        logging_log_util__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error("error tab manager -> unable to push event", error);
      }
    } else {
      logging_log_util__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error("error tab manager -> unable to find datalayer in window");
    }
  } else {}
};

var getPostType = function getPostType(postType) {
  if (postType === "text") {
    return "Read";
  } else if (postType === "video") {
    return "Video";
  } else if (postType === "audio") {
    return "Audio";
  } else if (postType) {
    return "Visual Stories";
  } else {
    return "Undefined";
  }
};

var createHomeArticlePayload = function createHomeArticlePayload(postStateData, extraInfo) {
  var _postStateData$hashta;

  var payload = {
    "Content ID": postStateData === null || postStateData === void 0 ? void 0 : postStateData._id,
    "Title": postStateData === null || postStateData === void 0 ? void 0 : postStateData.title,
    "Category": postStateData === null || postStateData === void 0 ? void 0 : postStateData.categoryName,
    "Sub Category": postStateData === null || postStateData === void 0 ? void 0 : postStateData.subCategoryName,
    // "Author name": "",
    // "Published Date": postStateData?.createdAt?.toLocaleDateString(),
    // "Published Time": postStateData?.createdAt?.toLocaleTimeString(),
    // "Published Date": (new Date(postStateData?.createdAt))?.toLocaleDateString(),
    // "Published Time": (new Date(postStateData?.createdAt))?.toLocaleTimeString(),
    "Published Date": postStateData === null || postStateData === void 0 ? void 0 : postStateData.createdAt,
    "Published Time": postStateData === null || postStateData === void 0 ? void 0 : postStateData.createdAt,
    "Hashtag Linked": postStateData === null || postStateData === void 0 ? void 0 : (_postStateData$hashta = postStateData.hashtags) === null || _postStateData$hashta === void 0 ? void 0 : _postStateData$hashta.join(" "),
    "Author Name": postStateData === null || postStateData === void 0 ? void 0 : postStateData.postedByName,
    "Share": postStateData === null || postStateData === void 0 ? void 0 : postStateData.shareCount,
    "Likes": postStateData === null || postStateData === void 0 ? void 0 : postStateData.likeCount,
    "Bookmarks": postStateData === null || postStateData === void 0 ? void 0 : postStateData.isBookmarked
  };

  if (extraInfo !== null && extraInfo !== void 0 && extraInfo.Section) {
    return _objectSpread(_objectSpread({}, payload), {}, {
      Section: extraInfo === null || extraInfo === void 0 ? void 0 : extraInfo.Section
    });
  } else {
    payload.Section = getPostType(postStateData === null || postStateData === void 0 ? void 0 : postStateData.type);
    return payload;
  }
}; // Bookmarks

/***/ }),

/***/ 78773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35005);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30767);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _templateObject;








var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  .modal {\n    height: 250px;\n    width: 350px;\n  }\n\n  .modalfooter .btn {\n    width: 10rem !important;\n  }\n"])));

var CustomPopup = function CustomPopup(_ref) {
  var showModal = _ref.showModal,
      onClose = _ref.onClose;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      contentClassName: "modal login-next",
      show: showModal,
      centered: true,
      dialogClassName: "frist-login",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Body */ .Z.Body, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "RegiModalBody",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                id: "this_feature",
                defaultMessage: "\u092F\u0939 \u092B\u0940\u091A\u0930 \u0907\u0938\u094D\u0924\u0947\u092E\u093E\u0932 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0932\u0949\u0917\u093F\u0928 \u0915\u0930\u0947\u0902"
              })
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Footer */ .Z.Footer, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "modalfooter",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "d-flex justify-content-between flex-direction-row",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              variant: "primary",
              type: "button",
              onClick: function onClick() {
                return router.push({
                  pathname: "/login",
                  query: {
                    callbackUrl: window.location.href
                  }
                });
              },
              children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                id: "signin",
                defaultMessage: "\u0938\u093E\u0907\u0928 \u0907\u0928 \u0915\u0930\u0947\u0902"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              variant: "primary",
              type: "button",
              onClick: onClose,
              children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                id: "close",
                defaultMessage: "\u092C\u0902\u0926 \u0915\u0930\u0947\u0902"
              })]
            })]
          })
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (CustomPopup);

/***/ })

}]);